import { IconComponentsProps } from './types';

const ChevronRightIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="16" height="16" viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z" />
  </svg>
);

export default ChevronRightIcon;
